export const ONBOARDING_V2_PREFLIGHT_PATH = '/onboarding';
export const ONBOARDING_V2_DASHBOARD_PATH = '/onboarding/dashboard';

export const ONBOARDING_V2_LEGACY_PREFLIGHT_PATH = '/preview/onboarding-v2';
export const ONBOARDING_V2_LEGACY_DASHBOARD_PATH = '/preview/onboarding-v2/dashboard';
